module.exports = __webpack_public_path__ + "img/network-pic.5f4a68d3.png";